import type { AppEnv } from '@shared/config/env'

type BuildClassReplayUrlParams = {
  serviceType: string
  zoomId: string
  studentToken: string
  pagecallReplayKeyValue: unknown
  appEnv: AppEnv
}

const REPLAY_ORIGIN_MAP: Record<string, string> = {
  PAGECALL: 'https://app.pagecall.com',
}

export const getPagecallReplayAccessToken = (pagecallReplayKeyValue: unknown, studentToken: string) => {
  const pagecallReplayKey = typeof pagecallReplayKeyValue === 'string' ? pagecallReplayKeyValue.trim() : ''
  return pagecallReplayKey || studentToken
}

export const buildClassReplayUrl = ({
  serviceType,
  zoomId,
  studentToken,
  pagecallReplayKeyValue,
  appEnv,
}: BuildClassReplayUrlParams) => {
  const isLemonboard = serviceType === 'LEMONBOARD'
  const origin = isLemonboard
    ? `https://${appEnv === 'production' ? '' : 'stage-'}lemonboard-web.re-speak.com`
    : REPLAY_ORIGIN_MAP.PAGECALL
  const roomIdKey = isLemonboard ? 'roomId' : 'room_id'
  const accessTokenKey = isLemonboard ? 'accessToken' : 'access_token'
  const accessToken =
    serviceType === 'PAGECALL' ? getPagecallReplayAccessToken(pagecallReplayKeyValue, studentToken) : studentToken
  const query = new URLSearchParams({ [roomIdKey]: zoomId, [accessTokenKey]: accessToken })

  return `${origin}/replay?${query.toString()}`
}
